import {
  WSIconName,
  WSBadge,
  WSBadgeProps,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { Card } from "../Card/Card";
import styles from "./PaymentType.module.scss";

export type PaymentTypeProps = {
  icon: WSIconName;
  title: string;
  description?: string;
  badge?: WSBadgeProps;
  feeText: string;
} & WSElementProps;

export const PaymentType: React.FC<PaymentTypeProps> = ({
  icon,
  title,
  description,
  badge,
  feeText,
  ...elementProps
}) => (
  <Card {...elementProps}>
    <WSFlexBox.CenterY wrap="nowrap">
      <WSElement className={styles.icon} mr="S">
        <WSIcon name={icon} />
      </WSElement>
      <WSElement className={styles.title}>
        <WSFlexBox.CenterY>
          <WSText.Heading3 mr="S">{title}</WSText.Heading3>
          {badge && <WSBadge {...badge} />}
        </WSFlexBox.CenterY>
        {description && <WSText>{description}</WSText>}
      </WSElement>
      <WSText.Label color="grey600">{feeText}</WSText.Label>
    </WSFlexBox.CenterY>
  </Card>
);
